import { Alert, Divider } from '@mui/material'
import type { $Base, $Table, $Top } from 'element-domain/src/__generated/enhanced-model'
import { Finishes } from 'element-domain/src/__generated/model'

import {
  AttributeCardSelector,
  AttributeToggleSelector,
  MaterialSwatchSelector,
} from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

interface WoodPropertyPageProps {
  tableId: $Table['id']
  top: $Top
  base: $Base
}

export default function WoodPropertyPage({ tableId, top, base }: WoodPropertyPageProps) {
  return (
    <PropertyContainer.Section title="Wood">
      <Divider sx={{ my: 2.5 }} />
      <PropertyContainer.Group spacing="large">
        <PropertyContainer.Item title="Wood Species">
          <AttributeCardSelector entityId={tableId} instanceName="woodSpecies" />
        </PropertyContainer.Item>

        <PropertyContainer.Item title="Top Finish">
          <MaterialSwatchSelector entityId={top.id} instanceName="finish" />
          {top.finish === Finishes.Custom &&
            top.$violations?.some(v => v.type === 'customTopFinishNeedsPersonalizedQuote') && (
              <Alert severity="warning" sx={{ mt: 1 }}>
                Custom finish needs a personalized quote.
              </Alert>
            )}
        </PropertyContainer.Item>

        <PropertyContainer.Item title="Base Finish">
          <MaterialSwatchSelector entityId={base.id} instanceName="finish" />
          {base.$violations?.some(v => v.type === 'customBaseFinishNeedsPersonalizedQuote') && (
            <Alert severity="warning" sx={{ mt: 1 }}>
              Custom finish needs a personalized quote.
            </Alert>
          )}
        </PropertyContainer.Item>

        <PropertyContainer.Item title="Sheen">
          <AttributeToggleSelector entityId={tableId} instanceName="sheens" columnCount={2} />
        </PropertyContainer.Item>

        <Divider sx={{ my: 2 }} />
        <Alert severity="info" sx={{ mt: 1 }}>
          Colors shown are general visual representations only. Final finish selection and approval should be confirmed
          with physical samples after order placement.
        </Alert>
      </PropertyContainer.Group>
    </PropertyContainer.Section>
  )
}
